import { Component, OnInit } from '@angular/core';
import { DeliveryMethod, MessagingSettings, Note, NoteResource, SettingsResource } from '@apaq/orgkit-js';
import { PageRequest } from '@apaq/leap-data-core';
import { container } from 'tsyringe';
import { Data, NotificationTemplateEditorViewComponent } from './notification-template-editor/notification-template-editor-view.component';
import { DialogService } from '../../dialog/dialog.service';

const TEMPLATE_ASSIGNMENT_IMPENDING = $localize`**Dear \$${'{'}contact.name${'}'}**
We will come next time \$${'{'}date${'}'} and do work.

Yours sincerely \$${'{'}organization.name${'}'}`;

const TEMPLATE_ASSIGNMENT_COMPLETED = $localize`**Dear \$${'{'}contact.name${'}'}**
We have completed work with you today.

Yours sincerely \$${'{'}organization.name${'}'}`;

type Event = {text: string, value: 'assignment.impending' | 'assignment.completed', state: boolean}

@Component({
  selector: 'app-notifications-view',
  templateUrl: './notifications-view.component.html',
  styleUrls: ['./notifications-view.component.scss']
})
export class NotificationsViewComponent implements OnInit {

  checked = false;
  messagingSettings?: MessagingSettings;
  loading?: string;
  //modalVisible = false;
  //modalSignatureVisible = false;
  //templateInEdit?: Note;
  //templateData?: Data;
  defaultCustomTemplates = {
    'assignment.impending': TEMPLATE_ASSIGNMENT_IMPENDING,
    'assignment.completed': TEMPLATE_ASSIGNMENT_COMPLETED
  };

  deliveryMethods: {text: string, value: DeliveryMethod, state: boolean}[] = [
    {text: $localize`Email`, value: 'Email', state: false},
    {text: $localize`SMS`, value: 'Sms', state: false}
  ];

  events: Event[] = [
    {text: $localize`Assignment is Completed`, value: 'assignment.completed', state: false},
    {text: $localize`Assignment is Impending (3 days in advance)`, value: 'assignment.impending', state: false}
  ];

  constructor(private dialogService: DialogService,
    private noteService: NoteResource,
    private settingsService: SettingsResource) { }

  initialized = false;

  ngOnInit() {
    this.load();
  }

  async load() {
    this.messagingSettings = await this.settingsService.findById('messaging') as MessagingSettings;
    this.resetStates();

    setTimeout(() => this.initialized = true, 10);
  }

  resetStates() {
    this.deliveryMethods.forEach(d => d.state = false);
    this.events.forEach(e => e.state = false);

    this.messagingSettings!.notificationDeliveryMethods.forEach(ndm => {
      this.deliveryMethods.forEach(current => {
        if (current.value === ndm) {
          current.state = true;
        }
      });
    });

    this.messagingSettings!.notificationEvents.forEach(ne => {
      this.events.forEach(current => {
        if (current.value === ne) {
          current.state = true;
        }
      });
    });
  }

  async submit(identifier: string) {
    if(!this.initialized) return;
    
    const deliveryMethods: DeliveryMethod[] = [];
    const events: string[] = [];

    this.loading = identifier;
    this.deliveryMethods.forEach(dm => {
      if (dm.state === true) {
        deliveryMethods.push(dm.value);
      }
    });

    this.events.forEach(e => {
      if (e.state === true) {
        events.push(e.value);
      }
    });

    this.messagingSettings!.notificationDeliveryMethods = deliveryMethods;
    this.messagingSettings!.notificationEvents = events;

    this.messagingSettings = await this.settingsService.saveAs(this.messagingSettings!, 'messaging') as MessagingSettings;
    this.resetStates();
    this.loading = undefined;
  }

  async editSignature() {
    const result = await Stallion.prompt($localize`Edit Signature`, this.messagingSettings!.notificationSignature, undefined, undefined, true);
    if(result) {
      this.messagingSettings!.notificationSignature = result;
      this.submit('');
    }
  }

  async editTemplate(event: Event) {
    const referenceId = `event:${event.value}`;
    const notes = (await this.noteService.findAll({query: {referenceId}} as PageRequest)).content;
    let templateInEdit = notes.length > 0 ? notes[0] : undefined;
    const data: Data = {
      event: event.value,
      template: templateInEdit ? templateInEdit.text : this.defaultCustomTemplates[event.value],
      templateMode: templateInEdit ? 'Custom' : 'Default'
    }

    this.dialogService.open(NotificationTemplateEditorViewComponent, $localize`Edit template`, {data}).afterClosed().subscribe((data: Data) => {
      if(data) {
        if (data.templateMode === 'Custom') {
          if (templateInEdit) {
            templateInEdit.text = data.template;
          } else {
            templateInEdit = { text: data.template, referenceId: `event:${data.event}` } as Note;
          }
          this.noteService.save(templateInEdit);
        } else if (templateInEdit) {
          this.noteService.delete(templateInEdit);
        }
      }
    });
  }
}
